import { ShoppingCart } from "@medusajs/icons"
import { clsx } from "clsx"

type CartNavButtonProps = {
  itemCount: number
  onOpen: () => void
  animationKey?: number
}

export const CartNavButton = ({
  itemCount,
  onOpen,
  animationKey = 0,
}: CartNavButtonProps) => {
  const badgeLabel = itemCount > 99 ? "99+" : String(itemCount)
  const shouldAnimate = animationKey > 0

  return (
    <button
      type="button"
      onClick={onOpen}
      aria-label={
        itemCount > 0
          ? `Open cart with ${itemCount} item${itemCount === 1 ? "" : "s"}`
          : "Open cart"
      }
      className={clsx(
        "relative w-9 h-9 rounded-full flex items-center justify-center text-[#5F5156] hover:text-[#F5928A] transition-colors",
        shouldAnimate && "cart-add-emphasis"
      )}
    >
      <span
        key={animationKey}
        className={clsx(
          "relative flex h-full w-full items-center justify-center rounded-full",
          shouldAnimate && "cart-add-pulse"
        )}
      >
        <ShoppingCart
          className={clsx(
            "relative z-10 w-5 h-5",
            shouldAnimate && "cart-add-icon-bounce"
          )}
          aria-hidden="true"
        />
        {itemCount > 0 ? (
          <span
            className={clsx(
              "absolute -right-0.5 -top-0.5 z-20 flex min-w-4 h-4 items-center justify-center rounded-full bg-[#F5928A] px-1 text-[10px] font-semibold leading-none text-[#2B2528] ring-2 ring-[#FFF9F8]",
              shouldAnimate && "cart-badge-pop"
            )}
          >
            {badgeLabel}
          </span>
        ) : null}
        {shouldAnimate ? (
          <span
            key={`added-${animationKey}`}
            aria-hidden="true"
            className="cart-added-callout"
          >
            Added
          </span>
        ) : null}
      </span>
    </button>
  )
}
